export default "__VITE_ASSET__VYt5ki$X__"